import { createContext, useContext } from 'react'
import { useMainContext } from "./main";
import { useLogout } from "../services/react-query/useAuthQuery";
import { useProfileSettings } from "../services/react-query/useProfileQuery";
import authService from '../services/authService';

const AuthContext = createContext()

export const useAuthContext = () => {
    return useContext(AuthContext)
}

export const AuthContextProvider = ({ children }) => {

    const { data: profileSettings } = useProfileSettings()

    const onLogout = () => {
        authService.logout()
    }
    const { mutate: logout, isLoading: loading } = useLogout(onLogout)

    return <AuthContext.Provider value={{ logout, loading, profileSettings }}>{children}</AuthContext.Provider>
}
